import { render, staticRenderFns } from "./MetadataSearchResult.vue?vue&type=template&id=91e9cf86"
import script from "./MetadataSearchResult.vue?vue&type=script&lang=js"
export * from "./MetadataSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports